import AdvertisingPlanPage from './AdvertisingPlanPage';

export default AdvertisingPlanPage;
